import { toast } from '@/shared/utils/UIHelper'

function advancedOnException (error, lang) {
  if (error.message === 'Unauthorized' || error.message === 'ExpiredToken' || error.message === 'Cannot read properties of undefined (reading \'status\')') {
    toast.error(lang.Common.SessionEnded)
    return
  }
  if (error.data && error.data.errors) {
    if (error.data.errors[0].message === 'could not execute statement; SQL [n/a]; constraint [pessoa.uk_document]; nested exception is org.hibernate.exception.ConstraintViolationException: could not execute statement') {
      toast.error('Documento já cadastrado')
      return
    }
    if (error.data.errors[0].identification === 'Usuário já existe') {
      toast.error('Nome de Usuário já cadastrado')
      return
    }
    if (error.data.errors[0].message === 'Senha inválida') {
      toast.error('Senha inválida')
      return
    }
    if (error.data.errors[0].identification) {
      toast.error(error.data.errors[0].identification)
      return
    }

    // MENSAGEM DE ERRO VINDA DO BACK-END
    if (error.data.errors[0].message) {
      toast.error(error.data.errors[0].message)
      return
    }
  }
  toast.error(lang.Common.MicroserviceUnavailable)
}

export { advancedOnException }



// WEBPACK FOOTER //
// ./src/components/tools/Utils.js